import { useState, useEffect, useRef } from "react";
import { ScrollFadeIn } from "@/components/ScrollFadeIn";
import { SystemColumn } from "./columns/SystemColumn";
import { InterfaceColumn } from "./columns/InterfaceColumn";
import { LightColumn } from "./columns/LightColumn";

export function RollingBarSection() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Dark gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[hsl(0,0%,7%)] via-[hsl(0,0%,3%)] to-[hsl(0,0%,0%)]" />

      <div className="relative z-10 px-6 py-24 md:py-32 lg:py-40">
        {/* Header */}
        <div className="mx-auto max-w-[1400px]">
          <ScrollFadeIn>
            <div className="mb-6">
              <h2 className="font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-[hsl(0,0%,92%)]">
                MINZO
              </h2>
              <p className="mt-2 font-serif text-2xl leading-snug text-[hsl(0,0%,88%)] md:text-3xl lg:text-4xl">
                Integrated Systems for Design&nbsp;Integrity
              </p>
            </div>
          </ScrollFadeIn>
          <ScrollFadeIn delay={80}>
            <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-[hsl(0,0%,50%)]">
              Control&ensp;/&ensp;Interface&ensp;/&ensp;Light
            </p>
          </ScrollFadeIn>

          {/* Divider */}
          <div className="my-16 h-px w-full bg-gradient-to-r from-transparent via-[hsl(0,0%,20%)] to-transparent md:my-20" />

          {/* 3-column grid */}
          <div className="grid gap-16 lg:grid-cols-3 lg:gap-8 xl:gap-12">
            <ScrollFadeIn delay={100}>
              <SystemColumn />
            </ScrollFadeIn>
            <ScrollFadeIn delay={200}>
              <InterfaceColumn />
            </ScrollFadeIn>
            <ScrollFadeIn delay={300}>
              <LightColumn />
            </ScrollFadeIn>
          </div>

          {/* Bottom line */}
          <div className="mt-20 h-px w-full bg-gradient-to-r from-transparent via-[hsl(0,0%,15%)] to-transparent md:mt-28" />
        </div>
      </div>
    </section>
  );
}
